import { ISODate } from "@core/types";

function formatDate(date: Date): ISODate {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}` as ISODate;
}

export function generateDeliveryDates(): ISODate[] {
  const currentDate = new Date();
  currentDate.setHours(currentDate.getHours() + 3);

  const currentMinutes = currentDate.getHours() * 60 + currentDate.getMinutes();

  const startDate = new Date(currentDate);
  if (currentMinutes > 1260) {
    startDate.setDate(startDate.getDate() + 1);
  }

  const dates: ISODate[] = [];
  for (let i = 0; i < 30; i++) {
    const date = new Date(startDate);
    date.setDate(startDate.getDate() + i);
    dates.push(formatDate(date));
  }

  return dates;
}
